<template>
  <v-container fluid >
    <v-layout justify-space-between text-xs-center>
        <v-card dark color="alert">
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">About (micro)decaPodVT</h3>
              <div>Everything you wanted to know about this app but were afraid to ask ...</div>
            </div>
          </v-card-title>
          <v-card-actions>
            <v-btn
            flat
            color="orange"
            @click.native.stop="dialog3 = true"            >
            >
            About
            </v-btn>
            <v-btn
            flat
            color="orange"
            :to="'/'"
            >
            Home
            </v-btn>
          </v-card-actions>
        </v-card>
      <v-flex xs4>
        <v-card dark color="alert">
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">CHANGELOG</h3>
              <div>A record of what is the what and what was the what.</div>
            </div>
          </v-card-title>
          <v-card-actions>
            <v-btn
            flat
            color="orange"
            @click.native.stop="dialog2 = true"            >
            CHANGELOG
            </v-btn>
            <v-btn
            flat
            color="orange"
            :to="'/'"
            >
            Home
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex xs4>
        <v-card dark color="alert">
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">Punch List</h3>
              <div>A sketch of the remaining work.</div>
            </div>
          </v-card-title>
          <v-card-actions>
            <v-btn
            flat
            color="orange"
            @click.native.stop="dialog = true"            >
            >
            Punch List
            </v-btn>
            <v-btn
            flat
            color="orange"
            :to="'/'"
            >
            Home
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="dialog"
      full-width
      transition="dialog-bottom-transition"
    >
    <v-card>
          <!--v-card-action v-for="item in punchlist" :key="item.category">
              <p>
                {{ item.category }}: {{ item.title }}
              </p>
          </v-card-action-->
        </v-card>
    </v-dialog>
    <v-dialog v-model="dialog2" max-width="500px">
      <v-card>
          <!--v-card-text>
            <p class="text-xs-left">
              Change Log
            </p>
            <p class="text-xs-left">
              v. 1.0.1 (11/15/17)
            </p>
            <p class="text-xs-left">
              started changelog and punchlist, added them as an "about" section
            </p>
            <p class="text-xs-left">
              v. 1.0.0 (11/14/17)
            </p>
            <p class="text-xs-left">
              deployed to https://micropodvt.firebaseapp.com/
            </p>
            <p class="text-xs-left">

            </p>
          </v-card-text-->
        </v-card>
    </v-dialog>
    <!--v-dialog v-model="dialog3" max-width="900px">
          <v-card>
            <v-card-title>
              <span>Dialog</span>
              <v-spacer></v-spacer>
            </v-card-title>
            <v-card-actions>
              <v-btn color="primary" flat @click.stop="dialog3=false">Close</v-btn>
            </v-card-actions>
            This is where I will explain new features. Basically, the latest update adds a bunch of vector maps as "alternates" to the raster maps. Should be faster, since raster maps are .png files and vector maps are instructions on how to draw .png files, but let's see. The maps are ... an evergreen problem. Also, there is a geolocation button, though I have yet to concoct a mechanism to hook that button up to the isochrone algorithm, which would/will be aweseome. I fiddled with the sign-in/sign-up process; hopefully no problems emerge. Anyway, my real focus now is on the product. I can't add a paywall until the product is superb. Every itiration is two steps forward, one step back, which is waaaay better than it has been. Seb
          </v-card>
        </v-dialog-->
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      dialog: false,
      dialog2: false,
      dialog3: true
    }
  },
  computed: {
    punchlist () {
      return this.$store.getters.punchlist
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/User/Introduction/Introduction.vue